import type { ComponentChildren } from "preact";

export interface Row {
  key: string;
  title: ComponentChildren;
  /** Under the title, smaller. */
  detail?: ComponentChildren;
  /** On the right: actions or a status. */
  aside?: ComponentChildren;
}

/** One row per thing (an organization, say) in a card: its name with details under it, actions on the right. */
export function RowList({ rows }: { rows: readonly Row[] }) {
  return (
    <ul class="divide-y divide-zinc-200 rounded-lg border border-zinc-200 bg-white">
      {rows.map((r) => (
        <li key={r.key} class="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 px-4 py-3">
          <div class="min-w-0">
            <div class="font-medium text-zinc-900">{r.title}</div>
            {r.detail ? <div class="mt-0.5 text-sm text-zinc-500">{r.detail}</div> : null}
          </div>
          {r.aside ? <div class="flex flex-wrap items-center gap-3">{r.aside}</div> : null}
        </li>
      ))}
    </ul>
  );
}
